import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        

        <div className="row">
          <div className="col-lg-12 mx-auto">
            <div className="policy-content">
              <h3>Your Privacy Matters</h3>
              {/* <p>At IBRLIVE, we are committed to protecting your privacy and personal information. This policy explains how we collect, use, and safeguard your data.</p> */}
              
              <h4>Who we are</h4>
              <p>Our website address is: <strong>http://ibrlive.com</strong></p>
              
              <h4>Comments</h4>
              <p>When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor's IP address and browser user agent string to help spam detection.</p>
              <p>An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: <a href="https://automattic.com/privacy/" target="_blank" rel="noopener noreferrer">https://automattic.com/privacy/</a>. After approval of your comment, your profile picture is visible to the public in the context of your comment.</p>
              
              <h4>Media</h4>
              <p>If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.</p>
              
              <h4>Cookies</h4>
              <p>If you leave a comment on our site you may opt-in to saving your name, email address and website in cookies. These are for your convenience so that you do not have to fill in your details again when you leave another comment. These cookies will last for one year.</p>
              <p>If you visit our login page, we will set a temporary cookie to determine if your browser accepts cookies. This cookie contains no personal data and is discarded when you close your browser.</p>
              <p>When you log in, we will also set up several cookies to save your login information and your screen display choices. Login cookies last for two days, and screen options cookies last for a year. If you select "Remember Me", your login will persist for two weeks. If you log out of your account, the login cookies will be removed.</p>
              <p>If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes no personal data and simply indicates the post ID of the article you just edited. It expires after 1 day.</p>
              
              <h4>Embedded content from other websites</h4>
              <p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.</p>
              <p>These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.</p>
              
              <h4>Who we share your data with</h4>
              <p>If you request a password reset, your IP address will be included in the reset email.</p>
              
              <h4>How long we retain your data</h4>
              <p>If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.</p>
              <p>For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.</p>
              
              <h4>What rights you have over your data</h4>
              <p>If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.</p>
              
              <h4>Where your data is sent</h4>
              <p>Visitor comments may be checked through an automated spam detection service.</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .policy-page {
          padding: 80px 0 0 0;
          min-height: 80vh;
        }
        
        .page-header {
          margin-bottom: 50px;
        }
        
        .page-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #333;
          margin-bottom: 15px;
        }
        
        .page-header p {
          font-size: 1.1rem;
          color: #666;
        }
        
        .policy-content {
          background: white;
          padding: 40px;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .policy-content h3 {
          font-size: 1.8rem;
          font-weight: 600;
          color: #333;
          margin: 25px 0 20px 0;
          border-bottom: 2px solid #007bff;
          padding-bottom: 10px;
        }
        
        .policy-content h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #555;
          margin: 25px 0 15px 0;
        }
        
        .policy-content p {
          font-size: 1rem;
          line-height: 1.6;
          color: #666;
          margin-bottom: 20px;
        }
        
        .policy-content ul {
          margin: 15px 0;
          padding-left: 20px;
        }
        
        .policy-content li {
          font-size: 1rem;
          line-height: 1.6;
          color: #666;
          margin-bottom: 8px;
        }
        
        .policy-content strong {
          color: #333;
          font-weight: 600;
        }
        
        @media (max-width: 768px) {
          .policy-content {
            padding: 20px;
          }
          
          .page-header h1 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;
